import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postShopeeCallback = async (body) => {
  const { data } = await SigliveServiceV1({ method: 'POST', url: `/account-livestream/shopee/auth/callback`, data: body });

  return data?.data;
};

export default postShopeeCallback;
